import { useQueryClient } from '@tanstack/react-query';
// mantine
import { Menu, UnstyledButton } from '@mantine/core';
import { modals } from '@mantine/modals';
// icons
import { Ellipsis, Edit, Trash2 } from 'lucide-react';
// components
import type { ITopic } from '@newo/api/gateway';
import StepForm from '@/pages/Workflow/components/StepForm';
// utils
import { openConfirmDeleteModal } from '@/utils/ui.tsx';
import { useDeleteTopicMutation } from '@/services/akb/akb.queries.ts';

interface ContextMenuProps {
    topic: ITopic;
}

const handleClose = () => {
    modals.closeAll();
};

const ContextMenu = ({ topic }: ContextMenuProps) => {
    const queryClient = useQueryClient();
    const deleteMutation = useDeleteTopicMutation();

    const handleEdit = () => {
        modals.open({
            title: 'Edit task',
            size: '70%',
            children: (
                <StepForm
                    personaId={topic.persona_id}
                    topic={topic}
                    onClose={handleClose}
                />
            )
        });
    };

    const handleDelete = () => {
        openConfirmDeleteModal({
            title: 'Delete Task?',
            children: 'Are you sure you want to delete task?',
            confirmLabel: 'Delete task',
            onConfirm: () => {
                deleteMutation.mutate(
                    { topicId: topic.topic_id },
                    {
                        onSuccess() {
                            queryClient.invalidateQueries({
                                queryKey: ['akb/topics']
                            });
                        }
                    }
                );
            }
        });
    };

    return (
        <Menu>
            <Menu.Target>
                <UnstyledButton>
                    <Ellipsis />
                </UnstyledButton>
            </Menu.Target>
            <Menu.Dropdown>
                <Menu.Item leftSection={<Edit />} onClick={handleEdit}>
                    Edit
                </Menu.Item>
                <Menu.Item leftSection={<Trash2 />} onClick={handleDelete}>
                    Remove
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    );
};

export default ContextMenu;
